<template>
    <layout :showuserinfo="false" title="Kemaskini" :crumbs="crumbs">
        <w-alert error outline v-if="hasSearched && hm.length == 0"
            >Tiada hak milik ditemui.</w-alert
        >
        <SemakHakMilikForm
            :districts="districts"
            :mukim="mukim"
            :jhm="jhm"
            :searching="searching"
            :form="form"
            @onSemak="onSemak"
            @onDaerahChange="fetchData1"
            :byBarcode="true"
            :byIdHM="true"
            :byMukimNoHM="false"
            :byJenisNoHM="false"
        ></SemakHakMilikForm>

        <w-card class="mt3 sh2" v-if="hm.length > 0">
            <div v-if="$zutil.can('Kemaskini Hakmilik')">
                <Hakmilik
                :cukai="hm[0]" :editable="true" />
            </div>
            <div v-else>
                <Hakmilik
                :cukai="hm[0]" :editable="false" />
            </div>

        </w-card>

        <w-card class="mt3 sh2" v-if="hm.length > 0" title="Maklumat Pemilik">
            <table class="mb2 table-dashboard" width="100%">
                <thead>
                    <tr>
                        <td>Pemilik</td>
                        <td>No. ID</td>
                        <td>No. Tel</td>
                        <td>Alamat 1</td>
                        <td>Alamat 2</td>
                        <td>Alamat 3</td>
                        <td>Poskod</td>
                        <td>Bandar</td>
                        <td>Negeri</td>
                        <td>Tindakan</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="p in hm[0].pemiliks">
                        <td>{{ p.nama }}</td>
                        <td>{{ p.no_kp }}</td>
                         <td>{{ p.no_tel }}</td>
                        <td>{{ p.alamat_1 }}</td>
                        <td>{{ p.alamat_2 }}</td>
                        <td>{{ p.alamat_3 }}</td>
                        <td>{{ p.poskod }}</td>
                        <td>{{ p.bandar }}</td>
                        <td>{{ p.negeri }}</td>
                        <td class="d-flex justify-center">
                            <!-- Dalam Penyelenggaraan -->
                            <w-button
                                @click="
                                    pemilikToEdit = p;
                                    dialogs.showKemaskiniPemilik = true;
                                "
                                text
                                :disabled="$zutil.can('Kemaskini Hakmilik')==false"
                            >
                                <w-icon> fal fa-pencil </w-icon>
                            </w-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </w-card>

        <w-card class="mt3 sh2" v-if="hm.length > 0" :title="`Maklumat Cukai (${this.hm[0].cukais.length ?? 0})`">
            <w-flex class="justify-end">
                <w-button @click="buatBayaran()" class="ml3" v-if="$zutil.can('Kemaskini Hakmilik')">
                    <!-- <w-icon class="mr3"> fal fa-money-bill-alt </w-icon> -->
                    Buat Bayaran
                </w-button>
                <w-button @click="this.dialogs.showTambahCukai = true" class="ml3" v-if="$zutil.can('Kemaskini Hakmilik')">
                    Tambah
                </w-button>
            </w-flex>
            <table class="mb2 table-dashboard" width="100%">
                <thead>
                    <tr>
                        <td>Tahun</td>
                        <td>Kod Hasil</td>
                        <td>Keterangan</td>
                        <td>Amaun</td>
                        <td class="text-center">Tindakan</td>
                    </tr>
                </thead>
                <tbody v-for="(p, index) in hm[0].cukais">
                    <tr >
                        <td >{{ p.tahun }}</td>
                        <td >{{ p.kod_hasil }}</td>
                        <!-- <td>{{ p.keterangan }}</td> -->
                        <td >
                            <w-badge
                                class="mr3"
                                top-right
                                v-if="p.tunggakan_dari && p.tunggakan_hingga"
                            >
                                <template #badge
                                    >{{
                                        p.tunggakan_dari
                                    }}&nbsp;-{{
                                        p.tunggakan_hingga
                                    }}</template
                                >
                                {{ p.keterangan }}
                            </w-badge>
                            <span v-if="!p.tunggakan_dari && !p.tunggakan_hingga">
                                {{ p.keterangan }}
                            </span>
                        </td>
                        <td class="text-right" >
                            {{ p.amaun_kredit > 0 ? moneyFormat(p.amaun_kredit) : moneyFormat(p.amaun_debit) }}
                        </td>
                        <td class="d-flex justify-center">
                            <w-button @click="deleteCukai(p,index)" color="red" text :loading="deleting" :disabled="$zutil.can('Kemaskini Hakmilik')==false">
                                <w-icon> fal fa-trash </w-icon>
                            </w-button>
                            <w-button @click="editCukai(p,index)" text :loading="deleting" :disabled="$zutil.can('Kemaskini Hakmilik')==false">
                                <w-icon> fal fa-pencil </w-icon>
                            </w-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </w-card>

        <w-card class="mt3 sh2" v-if="hm.length > 0" :title="`Maklumat Resit (${this.hm[0].terimaan.length ?? 0})`">
            <table class="mb2 table-dashboard" width="100%">
                <thead>
                    <tr>
                        <td>No. Resit</td>
                        <td>No Rujukan</td>
                        <td>Nama Pembayar</td>
                        <td>Cara Bayar</td>
                        <td>Amaun (RM)</td>
                        <td>Bank</td>
                        <td>Tarikh Bayar</td>
                        <td>Tarikh Batal</td>
                        <td>Status</td>
                        <!-- <td>Tindakan</td> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, index) in hm[0].terimaan">
                        <td>{{ p.no_resit }}


                        </td>
                        <td>{{ p.no_rujukan }} </td>
                        <td>
                            {{ p.nama_pembayar }}
                            <div v-if="p.no_tel_pembayar != null">
                                &nbsp;-{{ p.no_tel_pembayar }}
                            </div>
                        </td>
                        <td>
                            {{ p.cara_bayar }} ({{ p.kod_cara_bayar }})
                        </td>
                        <td class="text-right">{{ Number(p.amaun ).toFixed(2)}}</td>
                        <td>{{ p.bank }}</td>
                        <td>{{ moment(p.tarikh).format("DD-MM-YYYY h:mm A"
                                )}}</td>
                        <td>{{p.tarikh_batal}}</td>
                        <td>{{ p.status }}</td>
                        <!-- <td>
                            <w-button
                                @click="
                                    resitToEdit = p;
                                    dialogs.showKemaskiniResit = true;
                                "
                                text
                            >
                                <w-icon> fal fa-pencil </w-icon>
                            </w-button>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </w-card>
        <KemaskiniPemilikDialog
            :pemilik="pemilikToEdit"
            :show="dialogs.showKemaskiniPemilik"
            :no_hm="hm.length > 0 ? hm[0].no_hm : null"
            @close="dialogs.showKemaskiniPemilik = false"
            @onSuccess="successKemaskiniPemilik"
        ></KemaskiniPemilikDialog>
        <KemaskiniResitDialog
            :resit="resitToEdit"
            :show="dialogs.showKemaskiniResit"
            @close="dialogs.showKemaskiniResit = false"
            @onSuccess="successKemaskiniResit"
        ></KemaskiniResitDialog>
        <TambahCukaiDialog
            :hm="hm[0]"
            v-if="dialogs.showTambahCukai"
            :show="dialogs.showTambahCukai"
            @close="dialogs.showTambahCukai = false; cukaiToEdit = {}"
            @onSuccess="successTambahCukai"
            :cukaiToEdit="cukaiToEdit"
        />
    </layout>
</template>

<script>
import Table from "../../Component/Table";
import TablePagination from "../../Component/TablePagination";
import SemakHakMilikForm from "../../Component/SemakHakMilikForm";
import Hakmilik from "../../Component/Hakmilik";
import Namapemilik from "../../Component/Namapemilik";
import KemaskiniPemilikDialog from "./KemaskiniPemilikDialog";
import KemaskiniResitDialog     from "./KemaskiniResitDialog";
import TambahCukaiDialog from "./TambahCukaiDialog";
import moment from "moment";
import { moneyFormat } from "../helper/index";

export default {
    components: {
        Table,
        TablePagination,
        SemakHakMilikForm,
        Hakmilik,
        Namapemilik,
        KemaskiniPemilikDialog,
        KemaskiniResitDialog,
        TambahCukaiDialog,
    },
    props: {},
    data() {
        return {
            valid: null,
            validators: {
                required: (value) => !!value || "Sila Isi Ruangan Ini",
            },
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            pagination: {
                perPage: 10,
                currentPage: 1,
                lastPage: 1,
            },
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                {
                    label: "Kemaskini",
                    route: "",
                },
            ],

            districts: [],
            mukim: [],
            jhm: [],
            hm: [],
            form: {
                kod_daerah: "01",
                form_option: "option1",
                kategori_carian: "1",
                barcode: null,
                kod_mukim: null,
                kod_jenis_hm: null,
                tarikh_daftar: null,
                no_hm: "",
                no_bangunan: null,
                no_tingkat: null,
                no_petak: null,
                no_resit: null,
                no_kp: null,
            },
            search: {
                keyword: "",
                is_cukai_tanah: "",
            },
            searching: false,
            deleting: false,
            notFound: false,
            loading: false,
            hasSearched: false,
            total: 0,

            pemilikToEdit: {},
            resitToEdit: {},
            cukaiToAdd: {},
            cukaiToEdit: {},
            dialogs: {
                showKemaskiniPemilik: false,
                showKemaskiniResit: false,
                showTambahCukai: false,
            },
        };
    },
    computed: {
        getLastPage() {
            return this.total > 0
                ? Math.ceil(this.total / this.pagination.perPage)
                : 1;
        },
    },
    created: function () {
        this.moment = moment;
    },
    methods: {
        year(){
            const d = new Date();
            let year = d.getFullYear();
            return year;
        },
        moneyFormat,
        buatBayaran(){
            const url = `/kutipan/terimaan`;
            this.$inertia.get(url);
        },
        successTambahCukai(e) {
            if(Object.keys(this.cukaiToEdit).length > 0){
                const index = this.hm[0].cukais.findIndex(object => {
                    return object.id === this.cukaiToEdit.id;
                });
                this.hm[0].cukais[index] = e;
                this.cukaiToEdit = {};

            } else {
                this.hm[0].cukais.push(e)
            }
            this.dialogs.showTambahCukai = false
        },
        successKemaskiniResit(e){
            const index = this.hm[0].terimaan.findIndex(object => {
                return object.id === this.resitToEdit.id;
            });
            this.hm[0].terimaan[index] = e;

            this.dialogs.showKemaskiniResit = false
        },
        successKemaskiniPemilik(e){
            this.dialogs.showKemaskiniPemilik = false

            const index = this.hm[0].pemiliks.findIndex(object => {
                return object.id === this.pemilikToEdit.id;
            });
            this.hm[0].pemiliks[index] = e;
        },
        editCukai(e,index){
            this.cukaiToEdit = e;
            this.dialogs.showTambahCukai = true;
        },
        async deleteCukai(e,index) {
            this.deleting = true;
            await axios({
                method: "delete",
                url: `${this.apiBaseUrl}/cukai/kemaskini/hapus-cukai`,
                responseType: "json",
                data: {
                    hm_cukai_id: e.id,
                    hm:this.hm[0],
                    user_id:this.$page.props.auth.user.id,
                },
            })
                .then((e) => {
                    this.$waveui.notify({
                        success: true,
                        message: "Berjaya! Maklumat cukai telah dihapus.",
                        timeout: 3000,
                    });
                    this.hm[0].cukais.splice(index,1);
                })
                .catch(() => {
                    this.$waveui.notify({
                        error: true,
                        message: "Ralat.",
                        timeout: 3000,
                    });
                })
                .finally((e) => {
                    this.deleting = false;
                });
        },
        onSemak(e) {
            this.form = e;
            this.submit();
        },
        async submit() {
            this.searching = true;
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    this.hm = e.data;
                })
                .finally((e) => {
                    this.searching = false;
                    this.hasSearched = true;
                });
        },
        focusTab(e) {
            this.form.kategori_carian = e.id;
        },

        async fetchData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
                this.form.kod_daerah = this.districts[0].value;
            });
        },

        async fetchData2() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenisHm`,
                responseType: "json",
            }).then((e) => {
                this.jhm = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },
        async fetchData1() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah/${this.form.kod_daerah}/mukim`,
                responseType: "json",
            }).then((e) => {
                this.mukim = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },

        async init() {
            await this.fetchData();
            await this.fetchData1();
            await this.fetchData2();
        },
    },

    mounted() {
        this.init();
    },
};
</script>
<style>
div.w-menu.w-select__menu.w-menu--bottom.w-menu--align-left {
    z-index: 500;
}
</style>
